var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('password-form',{attrs:{"data":_vm.data,"event":"savePass"}}),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('btn-rounded',{attrs:{"label":"SALVAR","event":"savePass"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-068635e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Password/PasswordEdit.vue
// module id = UaYQ
// module chunks = 0